module.exports = __webpack_public_path__ + "img/SH2D_30008.eacfa0e6.png";